var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("p", { staticClass: "wrap" }, [
    _vm.showMessage
      ? _c("span", { staticClass: "message" }, [
          _vm._v("\n    " + _vm._s(_vm.i18n.lbl_wait_30()) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("span", { staticClass: "wait-text" }, [_vm._v(_vm._s(_vm.timerDisplay))])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c4a1a1b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c4a1a1b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/timer/Timer.vue
// module id = oXAy
// module chunks = 1